export default "__VITE_ASSET__CkqXCN0C__"